<template>
  <div>
    <div
      :class="{ bg_pad: bgPad === 'bg0' }"
      class="clearfix order_product"
      @click.stop="goOrderDetail(i.orderSn)"
    >
      <div class="left product_img_order">
        <img :src="item.skuPic" alt="" />
      </div>
      <div :class="{ border_bottom1px: pageShow }" class="right_item">
        <div
          class="name_name font12 font_weight400 colo0 font_line_2 text_left line_height_17"
        >
          {{ item.skuName }}
        </div>
        <div class="spec_line font10 font_weight400 colo055 text_left">
          <div class="name_spec">{{ item.skuSpec }}</div>
          <div class="tags_wrap">
            <tags
              v-if="$appSource != 3"
              :tradeType="item.tradeType"
              :includeTax="item.includeTax"
            />
            <div
              v-if="
                item.orderDetailLowerList && item.orderDetailLowerList.length
              "
              class="font9 some_tag"
            >
              分开发货
            </div>
          </div>
        </div>
        <div class="price_line">
          <div
            v-if="showPrice"
            class="product_price font14 font_weight600 colo087 line_height_16"
          >
            {{
              item.price || item.skuNowPrice || item.skuPrice | currency(false)
            }}
          </div>
          <div v-else></div>
          <div
            class="price_num font12 font_weight400 colo087 line_height_14 text_right"
          >
            ×{{ item.modifyNum || item.amount || item.skuAmount }}
          </div>
        </div>
      </div>
    </div>
    <!-- 组合商品显示 -->
    <div v-if="item.orderDetailLowerList && item.orderDetailLowerList.length">
      <div
        v-for="(i, index1) in item.orderDetailLowerList"
        :key="index1"
        class="order_product2"
      >
        <div class="product_img_order2">
          <img :src="i.skuPic" alt="" />
        </div>
        <div :class="{ border_bottom1px: pageShow }" class="right_item_pad">
          <!-- <div class="name_mr2"> -->
          <div
            class="name_name2 font12 font_weight400 colo055 font_line_2 text_left line_height_17"
          >
            {{ i.skuName }}
          </div>
          <!-- </div> -->
          <div class="font14 font_weight600 colo087 line_height_16 spec_2">
            <div class="font10 font_weight400 colo055 text_left">
              规格：{{ i.skuSpec }}
            </div>
            <div class="price_num font12 font_weight400 colo055 line_height_14">
              ×{{ i.modifyNum || i.amount || i.skuAmount }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const Tags = () => import("@/components/Tags").then(m => m.default || m);
export default {
  props: {
    listIndex: {
      type: Number,
      default: 0
    },
    pageShow: {
      type: Boolean,
      default: false
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    bgPad: {
      type: String,
      default: ""
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    },
    i: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {
    Tags
  },
  data() {
    return {};
  },
  methods: {
    goOrderDetail(orderSn) {
      this.$emit("goOrderDetail", orderSn);
    }
  }
};
</script>
<style lang="less" scoped>
.order_product2 {
  margin-left: 108px;
  display: flex;
  border-top: 1px dashed rgba(0, 0, 0, 0.2);
  padding-top: 12px;
  margin-right: 18px;
  .product_img_order2 {
    width: 56px;
    height: 56px;
    img {
      width: 100%;
      max-height: 56px;
    }
  }
  .spec_2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .right_item_pad {
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    min-width: 0;
  }
  .name_mr2 {
    width: 100%;
  }
  // .name_name2 {
  //   max-width: 152px;
  // }
}
.some_tag {
  margin-top: 12px;
  background: rgba(83, 121, 196, 0.12);
  border: 1px solid #5379c4;
  border-radius: 2px;
  font-size: 9px;
  font-weight: 400;
  padding: 0 4px;
  color: #5379c4;
}
.order_product {
  margin: 0 12px;
  // padding-right: 12px;
  .product_img_order {
    width: 96px;
    height: 96px;
    img {
      width: 100%;
      max-height: 96px;
    }
  }
  .right_item {
    margin-left: 108px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 96px;
    box-sizing: border-box;
    padding-bottom: 4px;
    .name_name {
      width: 100%;
    }
    .spec_line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .tags_wrap {
        display: flex;
        align-items: center;
        .some_tag {
          margin-top: 0;
          margin-left: 6px;
        }
      }
    }
    .price_line {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      width: 100%;
    }
  }
  .refund_status {
    color: #d91818;
    margin-top: 12px;
  }
}
.bg_pad {
  padding-right: 0 !important;
}
</style>
